<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fas fa-plug"></i> Ideiglenes fesz alá helyezések</h1>
			</div>
		</div>
		<panel title="Fesz. alá helyezések">
			<loading v-if="!temporary_reconnects"></loading>
			<no-records v-else-if="temporary_reconnects.length == 0" main_icon="fa fa-plug"
				title="Nem találhatóak ideiglenes fesz. alá helyezések"></no-records>
			<vue-good-table v-else :columns="columns" :rows="temporary_reconnects" :lineNumbers="false"
				:search-options="{ enabled: false, placeholder: 'Keresés...' }" :pagination-options="{
					perPage: 20,
					enabled: true,
					position: 'bottom',
					firstLabel: 'Első Lap',
					lastLabel: 'Utolsó Lap',
					nextLabel: 'következő',
					prevLabel: 'előző',
					rowsPerPageLabel: 'Sor oldalanként',
					ofLabel: '/',
					allLabel: 'Összes',
					infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
				}">
				<template slot="table-row" slot-scope="props">
					<span v-if="props.column.field == 'actions'">
						<router-link :to="'/isolations/' + props.row.isolation_id + '/edit'" class="btn btn-primary mx-1" title="feszmentesítéshez"><i
								class="fa fa-bolt"></i></router-link>
					</span>
					<span v-else-if="props.column.field == 'task_id'">
						<router-link :to="'/tasks/'+props.row.task_id+'/edit'" class="btn btn-dark btn-xs" title="munkafolyamathoz">{{ props.row.task_id }} <i class="fa fa-paper-plane"></i></router-link>
					</span>
					<span v-else>
						{{ props.formattedRow[props.column.field] }}
					</span>
				</template>
			</vue-good-table>
		</panel>
	</div>
</template>

<script>
import Loading from '../../components/Loading';
import NoRecords from '../../components/NoRecords';
import TemporaryReconnect from '../../apis/TemporaryReconnect';

export default {
	components: {
		Loading, NoRecords
	},
	data() {
		return {
			temporary_reconnects: false,
			columns: [
				{
					label: 'Mf. száma',
					field: 'task_id',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
					tdClass: 'fw-bold text-center',
					thClass: 'fw-bold text-center',
				},
				{
					label: 'Munkafolyamat megnevezése',
					field: 'name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
					width: '20%',
				},
				{
					label: 'Eredeti TV',
					field: 'original_location_leader',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
				},
				{
					label: 'Eredeti PV',
					field: 'original_owner',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
				},
				{
					label: 'Jelenlegi TV',
					field: 'location_leader',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
				},
				{
					label: 'Jelenlegi PV',
					field: 'owner',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
				},
				{
					label: 'Berendezés neve',
					field: 'position_name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
				},
				{
					label: 'Pozíciószám',
					field: 'position_id',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
				},
				{
					label: 'Fesz. alá helyezés kérvényezve',
					field: 'started_at',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés',
					},
				},
				{
					label: 'Műveletek',
					field: 'actions',
					width: '10%',
					sortable: false,
					thClass: 'text-end',
					tdClass: 'text-end',
				}
			],
		}
	},
	created() {
		TemporaryReconnect.index().then(response => {
			console.log(response.data);
			this.temporary_reconnects = response.data;
		})
	}
}
</script>